import { Button, ComboBox, IComboBoxOption, PrimaryButton, ProgressIndicator, Stack, TextField, themeRulesStandardCreator } from '@fluentui/react';
import * as React from 'react';
import { IContactInfo } from '../../../Models/ContactInfo/IContactInfo';
import { PageTitle } from '../../PageTitle';

interface IContactInfoViewProps {
    info?: IContactInfo;
    isLoading: boolean;
    changeInfoProperty: (key: string, value: any) => void;
    saveData: (data?: IContactInfo) => void;
}

const options: IComboBoxOption[] = [
    { key: 0, text: 'Nepoužívá se' },
    { key: 1, text: 'MoneyS3' },
]

export const ContactInfoView: React.FunctionComponent<IContactInfoViewProps> = (props) => {

    const textChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, newValue);
        }
    }

    return (<Stack>
        <PageTitle title="Kontaktní informace" />
        <Stack horizontalAlign="center">
            <Stack tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 40, minWidth: 400 } }}>
                <TextField disabled={props.isLoading} id="company" label="Název společnosti" value={props.info?.company} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="ic" label="IČ" value={props.info?.ic} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="dic" label="DIČ" value={props.info?.dic} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="registrationInfo" label="Registrace" value={props.info?.registrationInfo} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="bankAccount" label="Číslo účtu" value={props.info?.bankAccount} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="iban" label="IBAN" value={props.info?.iban} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="invoiceNoTemplate" label="Formát čísla faktury" value={props.info?.invoiceNoTemplate} onChange={textChanged} />

                <TextField disabled={props.isLoading} id="street" label="Ulice" value={props.info?.street} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="city" label="Obec" value={props.info?.city} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="postalCode" label="PSČ" value={props.info?.postalCode} onChange={textChanged} />

                <TextField disabled={props.isLoading} id="phoneNumber" label="Telefon" value={props.info?.phoneNumber} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="email" label="E-mail" value={props.info?.email} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="web" label="WWW" value={props.info?.web} onChange={textChanged} />

                <TextField disabled={props.isLoading} id="defaultDueDays" label="defaultDueDays" value={props.info?.defaultDueDays.toString()} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="dphSnizena1" label="dphSnizena1" value={props.info?.dphSnizena1.toString()} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="dphSnizena2" label="dphSnizena2" value={props.info?.dphSnizena2.toString()} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="dphZaklad" label="dphZaklad" value={props.info?.dphZaklad.toString()} onChange={textChanged} />

                <ComboBox label="Exportovat do účetnictní" selectedKey={props.info?props.info.erpSystem:0} options={options} onChange={(e, o) => { props.changeInfoProperty("erpSystem", o ? o.key:0); }} />
                <TextField disabled={props.isLoading} id="predkontace" label="Předkontace" value={props.info?.predkontace.toString()} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="kodDPH" label="Kod DPH" value={props.info?.kodDPH.toString()} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="eShopId" label="eShopId" value={props.info?.eShopId.toString()} onChange={textChanged} />
                <TextField disabled={props.isLoading} id="exportovatDnyPoVytvoreni" label="exportovatDnyPoVytvoreni" value={props.info?.exportovatDnyPoVytvoreni.toString()} onChange={textChanged} />
                
                <Stack styles={{ root: { height: 10 } }}>
                    {props.isLoading ? <ProgressIndicator /> : null}
                </Stack>
                <Stack horizontalAlign="center" styles={{ root: { paddingTop: 20 } }}>                    

                    <PrimaryButton disabled={props.isLoading} text="Uložit" onClick={() => props.saveData(props.info)} />                    
                </Stack>
            </Stack>
            
        </Stack>
      </Stack>)
}
